export default __webpack_public_path__ + "static/media/Back_Steel_Black.d193f1ab.png";